import { render } from "./nav-bar.vue?vue&type=template&id=49c87ac3&scoped=true"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=49c87ac3&scoped=true&lang=css"

import exportComponent from "/home/aaicom7/repositories/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c87ac3"]])

export default __exports__